/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import {message} from 'antd'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import {ExcelExport, grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Select from 'react-select'
import SearchProduct from '../BaseComponent/SearchProduct'
import Loader from '../loaders/loader'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import {voip} from './call/voip'
import AutoComplete from '../BaseComponent/autocomplete'

class Invoice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      baskets: [],
      lengthbaskets: 0,
      urlSign: '',
      Drivers: [],
      tasvie: '',
      state: '',
      printInfo: [],
      aggregation: {},
      fromRegDate: '',
      toRegDate: '',
      excelReport: [],
      buttonClicked: false,
      selectedStockProductIds: [],
      arrayOfStocks: [],
      finalStocks: [],
      multiUnit: [],
      unitArr: [],
      multiProvider: [],
      productArr: [],
      providerArr: [],
      pageNumber: 1,
      pageSize: 10,
      providers: [],
      sortBy: 'registerDate_desc',
      sortData: [
        {
          name: 'ردیف',
          value: 'supplyDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شماره فاکتور',
          value: 'invoiceNum',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'خریدار',
          value: 'buyerName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد مشتری',
          value: 'userCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد ملی',
          value: 'nationalId',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'تحویل گیرنده',
          value: 'recipientName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'موبایل',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت پرداخت',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت تایید',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ ثبت',
          value: 'registerDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ تایید',
          value: 'confirmDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'پرداخت در محل',
          value: 'confirmDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'قابل پرداخت',
          value: 'confirmDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'جزییات',
          value: 'confirmDate',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      tablePageNumber: 1,
      providerId: ''
    }
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_INVOICE_MASTER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            $('.showBaseTable,.print').fadeIn()

            sessionStorage.setItem('countAll', response.data.object.countAll)
            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              baskets: response.data.object.result,
              lengthbaskets: response.data.object.countAll,
              buttonClicked: true,
              loading: false,
              countAll: response.data.object.countAll
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          message.error(response.data.description)

          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let {providerArr, unitArr, finalStocks} = this.state
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let buyerName = document.getElementById('buyerName').value
    let userCode = document.getElementById('userCode').value.trim()
    let nationalId = document.getElementById('nationalId').value.trim()
    let mobile = document.getElementById('mobile').value.trim()
    let recipientName = document.getElementById('recipientName').value.trim()
    let paid = document.getElementById('paid').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let payableAmountMin = this.convertDigit(document.getElementById('payableAmountMin').value.trim())
    let payableAmountMax = this.convertDigit(document.getElementById('payableAmountMax').value.trim())
    let providerId = this.state.providerId
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (providerId) {
      filter.providerIds = providerId
    }
    if (finalStocks.length !== 0) {
      filter.stockProductIds = finalStocks.join(',')
    }
    if (unitArr.length !== 0) {
      filter.productUnitIds = unitArr.join(',')
    }
    if (unitArr.fromRegDate !== '') {
      filter.registerDateMin = fromRegDate
    }
    if (unitArr.toRegDate !== '') {
      filter.registerDateMax = toRegDate
    }
    if (unitArr.payableAmountMin !== '') {
      filter.payableAmountMin = payableAmountMin
    }
    if (unitArr.payableAmountMax !== '') {
      filter.payableAmountMax = payableAmountMax
    }
    if (unitArr.buyerName !== '') {
      filter.buyerName = buyerName
    }
    if (unitArr.invoiceNum !== '') {
      filter.invoiceNum = invoiceNum
    }
    if (unitArr.invoiceId !== '') {
      filter.invoiceId = invoiceId
    }
    if (unitArr.payOnDelivery !== '') {
      filter.payOnDelivery = payOnDelivery
    }
    if (unitArr.canceled !== '') {
      filter.canceled = canceled
    }
    if (unitArr.confirmed !== '') {
      filter.confirmed = confirmed
    }
    if (unitArr.paid !== '') {
      filter.paid = paid
    }
    if (unitArr.recipientName !== '') {
      filter.recipientName = recipientName
    }
    if (unitArr.mobile !== '') {
      filter.mobile = mobile
    }
    if (unitArr.nationalId !== '') {
      filter.userNationalId = nationalId
    }
    if (unitArr.userCode !== '') {
      filter.userCode = userCode
    }
    return filter
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidMount() {
    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_UNIT}`, {}).then((response) => {
      if (response.data.error == null) {
        var unit = response.data.object
        for (let i = 0; i < unit.length; i++) {
          unit[i]['value'] = unit[i].id
          unit[i]['label'] = unit[i].title
        }

        this.setState({
          unit: response.data.object
        })
      } else {
        this.setState({
          unit: []
        })
      }
    })

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{

    // }).then((response)=>{
    //     if(response.data.error==null){

    //         var provider = response.data.object;
    //         for (let i = 0; i < provider.length; i++) {
    //             provider[i]['value'] = provider[i].providerId;
    //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
    //         }

    //         this.setState({
    //             providers:response.data.object
    //         })
    //     }
    //     else{
    //         this.setState({
    //             providers:[]
    //         })
    //     }
    // })

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      baskets: data
    })
  }

  changeDropDown(data) {
    this.setState({
      baskets: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  handleChangeFromRegDate = (fromRegDate) => {
    this.setState({
      fromRegDate
    })
  }

  handleChangeToRegDate = (toRegDate) => {
    this.setState({
      toRegDate
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value

    this.setState({
      tasvie: value == '' ? '' : Number(value)
    })
  }

  changeState(e) {
    let target = e.target
    let value = target.value

    this.setState({
      state: value
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate
    if (fromRegDate === '' || toRegDate === '') {
      message.error('هر دو تاریخ وارد شود')
    }
    // if (Object.keys(this.createFilter(false)).length - 3 === 0) {
    //     message.error("حداقل یک فیلتر وارد شود");
    // }
    else if ((fromRegDate != '' || fromRegDate == null) && isNaN(fromRegDate)) {
      message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    } else if ((toRegDate != '' || toRegDate == null) && isNaN(toRegDate)) {
      message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: fromRegDate == '' ? '-' : jMoment(this.state.fromRegDate).format('jYY/jMM/jDD'),
        fromPrintDate: toRegDate == '' ? '-' : jMoment(this.state.toRegDate).format('jYY/jMM/jDD'),
        loading: true,
        pageNumber: 1
      })
      setTimeout(() => {
        this.getReport(false)
      }, 500)
    }
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_INVOICE_MASTER}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['invoice'].mobile == null) {
              excelReport[i]['invoice'].mobile = '-'
            } else {
              excelReport[i]['invoice'].mobile = excelReport[i]['invoice'].mobile.replace(/\+98/g, '0')
            }

            if (excelReport[i]['invoice'].confirmDate == null) {
              excelReport[i]['invoice'].confirmDate = '-'
            } else {
              excelReport[i]['invoice'].confirmDate = jMoment(excelReport[i]['invoice'].confirmDate).format(
                'jYY/jMM/jDD'
              )
            }

            if (excelReport[i]['invoice'].registerDate == null) {
              excelReport[i]['invoice'].registerDate = '-'
            } else {
              excelReport[i]['invoice'].registerDate = jMoment(excelReport[i]['invoice'].registerDate).format(
                'jYY/jMM/jDD'
              )
            }

            if (excelReport[i]['invoice'].paid) {
              excelReport[i]['invoice'].paid = 'پرداخت شده'
            } else {
              excelReport[i]['invoice'].paid = 'پرداخت نشده'
            }

            if (excelReport[i]['invoice'].canceled) {
              excelReport[i]['invoice'].canceled = 'کنسل شده'
            } else {
              excelReport[i]['invoice'].canceled = 'کنسل نشده'
            }

            if (excelReport[i]['invoice'].confirmed) {
              excelReport[i]['invoice'].confirmed = 'بله'
            } else {
              excelReport[i]['invoice'].confirmed = 'خیر'
            }

            if (excelReport[i]['invoice'].payOnDelivery) {
              excelReport[i]['invoice'].payOnDelivery = 'بله'
            } else {
              excelReport[i]['invoice'].payOnDelivery = 'خیر'
            }

            if (excelReport[i]['invoice'].driver == null) {
              excelReport[i]['invoice'].driver = ''
            } else {
              excelReport[i]['invoice'].driver = excelReport[i]['invoice'].driver.name
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  handleChangeUnit = (multiUnit) => {
    var unitArr = []
    this.setState({multiUnit})
    // alert(multiUnit.length)
    if (multiUnit.length == '0') {
      this.setState({
        unitArr: []
      })
    } else {
      for (let prop of multiUnit) {
        unitArr.push(prop.id)
        this.setState({
          unitArr: unitArr
        })
      }
    }
  }
  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  callToCustomer = (mobile, buyerName) => {
    if (mobile === '') {
      message.error('شماره موبایل مورد نظر وجود ندارد')
    } else {
      this.setState({
        showMobileCallModal: true
      })
      let internalPhone = '725'
      voip(mobile, buyerName)
        .then(() => {
          message.success('تماس برقرار شد لطفا منتظر پاسخ بمانید')
        })
        .catch((err) => {
          message.error(err)
        })
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    const {urlSign} = this.state
    let reporterName = cookie.load('name')

    let printCol = [
      'ردیف',
      'شناسه فاکتور',
      'شماره فاکتور',
      'خریدار',
      'کد مشتری',
      'کد ملی',
      'تحویل گیرنده',
      'موبایل',
      'پرداخت',
      'تایید',
      'تاریخ ثبت',
      'تاریخ تایید',
      'پرداخت در محل',
      'قابل پرداخت'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش فاکتور.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'خریدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'nationalId'}
                field={'customer.nationalId'}
                title={'کد ملی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'recipientName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'نام خریدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'پرداخت شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'confirmed'}
                field={'invoice.confirmed'}
                title={'تایید شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'canceled'}
                field={'invoice.canceled'}
                title={'وضعیت کنسل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'registerDate'}
                field={'invoice.registerDate'}
                title={'تاریخ ثبت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'confirmDate'}
                field={'invoice.confirmDate'}
                title={'تاریخ تایید'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'invoice.payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست گزارشات فاکتور"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={18}
              rightColSpan={9}
              centerColSpan={1}
              leftColSpan={8}
              centerSection={''}
              rightSection={'تاریخ ثبت از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((items, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{items.invoice.invoiceId}</td>
                  <td>{items.invoice.invoiceNum}</td>
                  <td>{items.invoice.buyerName}</td>
                  <td>{items.customer.userCode}</td>
                  <td>{items.customer.nationalId}</td>
                  <td>{items.invoice.recipientName}</td>
                  <td className="mobileTD">
                    {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                  </td>
                  <td className="smallPhoto">
                    {items.invoice.paid ? (
                      <img src={require('../../image/confirm.svg')} />
                    ) : (
                      <img src={require('../../image/ignor.svg')} />
                    )}
                  </td>
                  <td className="smallPhoto">
                    {items.invoice.confirmed ? (
                      <img src={require('../../image/confirm.svg')} />
                    ) : (
                      <img src={require('../../image/ignor.svg')} />
                    )}
                  </td>
                  <td>
                    {items.invoice.registerDate == null
                      ? '-'
                      : jMoment(items.invoice.registerDate).format('jYYYY/jMM/jDD HH:mm')}
                  </td>
                  <td>
                    {items.invoice.confirmDate == null
                      ? '-'
                      : jMoment(items.invoice.confirmDate).format('jYYYY/jMM/jDD HH:mm')}
                  </td>
                  <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                  <td className="priceCell">{accounting.formatMoney(items.invoice.payableAmount, '', ',')}</td>
                </tr>
              ))}
              {/*<tr>*/}
              {/*    <td colSpan={13}>مجموع</td>*/}
              {/*    <td className='priceCell'>{accounting.formatMoney(this.state.aggregation.payableAmount,'',',')}</td>*/}
              {/*</tr>*/}
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>فاکتور</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromRegDate}
                  onChangeToDate={this.handleChangeToRegDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue={true}
                  fromId="fromReg"
                  toId="toReg"
                  force
                />

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input
                    type="text"
                    defaultValue={this.state.invoiceId}
                    className="form-control"
                    id="invoiceId"
                    name="invoiceId"
                  />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>کد مشتری:</label>
                  <input
                    type="text"
                    defaultValue={this.state.userCode}
                    className="form-control"
                    id="userCode"
                    name="userCode"
                  />
                </div>

                <div className="formComponent">
                  <label>کد ملی مشتری:</label>
                  <input type="text" className="form-control" id="nationalId" name="nationalId" />
                </div>

                <div className="formComponent">
                  <label>موبایل (در فاکتور) : </label>
                  <input type="text" className="form-control" id="mobile" name="mobile" />
                </div>

                <div className="formComponent">
                  <label>نام خریدار (در فاکتور) :</label>
                  <input type="text" className="form-control" id="buyerName" name="buyerName" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده (در فاکتور) :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>

                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed" name="confirmed">
                    <option value="">-------</option>
                    <option selected={true} value={1}>
                      تایید شده
                    </option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت کنسل :</label>
                  <select className="form-control" id="canceled" name="canceled">
                    <option value="">-------</option>
                    <option value={1}>کنسل شده</option>
                    <option selected={true} value={0}>
                      کنسل نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="paid" name="paid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت از :</label>
                  <input type="text" className="form-control" id="payableAmountMin" name="payableAmountMin" />
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت تا :</label>
                  <input type="text" className="form-control" id="payableAmountMax" name="payableAmountMax" />
                </div>

                <div className="formComponent">
                  <label>واحد کالا :</label>
                  <Select
                    value={this.state.multiUnit}
                    onChange={this.handleChangeUnit}
                    options={this.state.unit}
                    isMulti={true}
                    isClearable={true}
                    placeholder=""
                  />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده ها :</label>
                                    <Select
                                        value={this.state.multiProvider}
                                        onChange={this.handleChangeProvider}
                                        options={this.state.providers}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder=''
                                    /> */}
                </div>
              </div>
              <div>
                {this.state.providers.length ? (
                  <SearchProduct
                    providers={this.state.providers}
                    getStocks={this.getStocks}
                    finalStocks={this.finalStocks}
                  />
                ) : null}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable" ref={(node) => (this.printTable = node)}>
                <Sort data={this.state.sortData} getSort={this.getSort} />

                <tbody>
                  {this.state.baskets.map((items, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>
                        <Link
                          to={{
                            pathname: '/baskets',
                            search: `?invoiceId=${items.invoice.invoiceId}&userCode=${items.customer.userCode}`
                          }}
                          target={'_blank'}
                        >
                          {items.invoice.invoiceId}
                        </Link>
                      </td>
                      <td>{items.invoice.invoiceNum}</td>
                      <td>{items.invoice.buyerName}</td>
                      <td>
                        <Link target="_blank" to={`/base/users/persina/${items.customer.userCode}`}>
                          {items.customer.userCode}
                        </Link>
                      </td>
                      <td>{items.customer.nationalId}</td>
                      <td>{items.invoice.recipientName}</td>
                      <td className="">
                        <button
                          title="تماس"
                          className="btn btn-sm btn-success text-dark font-weight-bold"
                          onClick={() =>
                            this.callToCustomer(
                              items.invoice.mobile == null ? '' : items.invoice.mobile.replace(/\+98/g, '0'),
                              items.invoice.buyerName
                            )
                          }
                        >
                          <span className="text-dark font-weight-bold" style={{color: '#000'}}>
                            {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                          </span>
                        </button>
                      </td>
                      <td className="smallPhoto">
                        {items.invoice.paid ? (
                          <img src={require('../../image/confirm.svg')} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} />
                        )}
                      </td>
                      <td className="smallPhoto">
                        {items.invoice.confirmed ? (
                          <img src={require('../../image/confirm.svg')} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} />
                        )}
                      </td>
                      <td>
                        {items.invoice.registerDate == null
                          ? '-'
                          : jMoment(items.invoice.registerDate).format('jYYYY/jMM/jDD HH:mm')}
                      </td>
                      <td>
                        {items.invoice.confirmDate == null
                          ? '-'
                          : jMoment(items.invoice.confirmDate).format('jYYYY/jMM/jDD HH:mm')}
                      </td>
                      <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                      <td className="priceCell">{accounting.formatMoney(items.invoice.payableAmount, '', ',')}</td>

                      <td>
                        <Link
                          to={`/detailsInvoice/${items.invoice.invoiceId}/${items.invoice.invoiceNum}/${
                            items.invoice.buyerName
                          }`}
                          target="_blank"
                        >
                          <img src={require('../../image/details.svg')} alt="" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                  {/*<tr>*/}
                  {/*    <td colSpan={13}>مجموع</td>*/}
                  {/*    <td className='priceCell'>{accounting.formatMoney(this.state.aggregation.payableAmount,'',',')}</td>*/}
                  {/*    <td></td>*/}
                  {/*</tr>*/}
                </tbody>
              </table>
              <Modal isOpen={this.state.modal} toggle={this.toggle} size="sm">
                <ModalHeader toggle={this.toggle}>نمایش امضا</ModalHeader>
                <ModalBody>
                  <div className="imageSign">
                    <img src={urlSign} alt="" />
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="danger" onClick={this.handleCancel}>
                    بستن
                  </Button>
                </ModalFooter>
              </Modal>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.showMobileCallModal} toggle={() => this.setState({showMobileCallModal: false})}>
          <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
            <h3 className="font-weight-bold">تماس با کاربر برقرار شد</h3>
            <button className="btn btn-success" onClick={() => this.setState({showMobileCallModal: false})}>
              بستن
            </button>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default Invoice
